import { ProfileImage } from "./styles";

export function ProfileAbout() {
    return (
        <ProfileImage/>
    )
}